import { RuleTemplate } from 'store/dataRaptorRule/types';
import { apiCall } from '../index';

export const getRuleTemplatesByDataSourceId = (dataSource: string): Promise<RuleTemplate[]> =>
  apiCall({
    method: 'get',
    url: `/data-raptor-rule-template/dataSource/${dataSource}`,
  });
